import { useEffect, useState } from "preact/hooks";
import { useAgent } from "../providers/AgentProvider";
import { motion } from "motion/react";

export default function LoadingScreen() {
  const { agentData } = useAgent();
  const [progress, setProgress] = useState(0);
  const MAX_PROGRESS = 96;
  const LOADING_DURATION = 10000; // 10 seconds

  useEffect(() => {
    const startTime = Date.now();

    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / LOADING_DURATION) * 100, MAX_PROGRESS);
      setProgress(newProgress);

      if (newProgress < MAX_PROGRESS) {
        requestAnimationFrame(updateProgress);
      }
    };

    requestAnimationFrame(updateProgress);
  }, []);

  const imgUrl = agentData?.image_url;

  return (
    <div className="absolute inset-0 w-full h-full flex flex-col items-center justify-center">
      {/* Dark underlay */}
      <div className="absolute inset-0 w-full h-full bg-black" />

      {/* Blurred background image */}
      {imgUrl && (
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center scale-125"
          style={{
            backgroundImage: `url(${imgUrl})`,
            filter: "blur(25px) brightness(0.5)",
          }}
        />
      )}

      {/* Everything that should blur on mount */}
      <motion.div
        initial={{ filter: "blur(12px)", opacity: 0 }}
        animate={{ filter: "blur(0px)", opacity: 1 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
        className="absolute inset-0 w-full h-full flex flex-col items-center justify-center px-8"
      >
        <div className="flex flex-col items-center text-white">
          {/* Main text */}
          <h2 className="text-lg font-medium mb-2 text-center">You're about to speak with an AI.</h2>

          {/* Progress bar */}
          <div className="w-25 h-3 bg-white/30 rounded-full overflow-hidden mb-6">
            <div
              className="h-full bg-white rounded-full transition-all duration-100 ease-linear"
              style={{ width: `${progress}%` }}
            />
          </div>

          {/* Disclaimer */}
          <div className="flex justify-center">
            <span className="font-light text-xs text-center text-white">
              This call may be recorded and shared with our service providers.{" "}
              <a
                href="https://lemonslice.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline decoration-white/50 hover:text-white transition-colors"
              >
                Learn more
              </a>
            </span>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
